import React from 'react';
import { Box, TextField, MenuItem, Typography, Grid, Alert, AlertTitle } from '@mui/material';
import { FinancialYearState } from '../types';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

interface FinancialYearStepProps {
  state: FinancialYearState;
  options: Array<{ option: string; value: string }>;
  selectedOption: string;
  setSelectedOption: (option: string) => void;
  setSelectedYear: (year: number) => void;
  error: string;
  formErrors?: { startYear?: string; endYear?: string };
}

export const FinancialYearStep: React.FC<FinancialYearStepProps> = React.memo(
  ({ state, options, selectedOption, setSelectedYear, error, formErrors }) => {
    return (
      <Box>
        <Typography
          variant="h5"
          component="h2"
          sx={{
            fontWeight: 'bold',
            fontSize: '20px',
            mb: '5px',
          }}
        >
          Financial Year Creation
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4} lg={2}>
            <Typography variant="subtitle2" gutterBottom>
              FY Start & End Month
            </Typography>
            <TextField select fullWidth size="small" value={selectedOption} disabled>
              {options.map(({ option, value }) => (
                <MenuItem key={value} value={value}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={4} lg={2}>
            <Typography variant="subtitle2" gutterBottom>
              Start Year
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                openTo="year"
                views={['year']}
                disabled
                value={state.startYear === 0 ? null : dayjs(state.startYear.toString())}
                onChange={(d, keyboardInputValue) => {
                  if (d) {
                    setSelectedYear(d.year());
                  } else {
                    setSelectedYear(0);
                  }
                }}
                slots={{
                  textField: (params) => <TextField {...params} fullWidth size="small" error={!!formErrors?.startYear} />,
                }}
              />
            </LocalizationProvider>{' '}
          </Grid>

          <Grid item xs={12} md={4} lg={2}>
            <Typography variant="subtitle2" gutterBottom>
              End Year
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                openTo="year"
                views={['year']}
                value={state.endyear === 0 ? null : dayjs(state.endyear.toString())}
                slots={{
                  textField: (params) => <TextField {...params} fullWidth size="small" />,
                }}
                disabled
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <Box mt={2}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              fontSize: '16px',
            }}
          >
            Preview: {state.fyPreview}
          </Typography>
        </Box>
        {error && (
          <Alert severity="warning">
            <AlertTitle>Warning</AlertTitle>
            {error}
          </Alert>
        )}
      </Box>
    );
  }
);
